import { translation, TranslatedComponent } from '@hh.ru/front-static-app';
import { useSelectorNonNullable } from '@hh.ru/redux-create-reducer';
import Text, { TextImportance, TextSize } from 'bloko/blocks/text';
import VSpacing from 'bloko/blocks/vSpacing';

import formatDate from 'src/utils/formatDate';

import ForResume from 'src/pages/ApplicantServicesOrder/components/ResumeAudit/ForResume';

import styles from './index.less';

const TrlKeys = {
    recommendationTitle: 'applicantService.resumeaudit.comment.title',
};

const WaitingRecommendation: TranslatedComponent = ({ trls }) => {
    const order = useSelectorNonNullable(({ resumeAuditOrder }) => resumeAuditOrder);
    return (
        <>
            <ForResume {...order.resume} />
            <VSpacing base={8} />
            <div className={styles.recommendation}>
                <Text size={TextSize.Large} strong>
                    {trls[TrlKeys.recommendationTitle]}
                </Text>
                <VSpacing base={4} />
                {order.commentDate && (
                    <>
                        <Text importance={TextImportance.Secondary}>{formatDate(order.commentDate, 'd MMMM')}</Text>
                        <VSpacing base={2} />
                    </>
                )}
                {!!order.comment && (
                    <Text>
                        <div
                            className={styles.comment}
                            dangerouslySetInnerHTML={{ __html: order.comment.replace(/\n/gi, '<br />') }}
                        ></div>
                    </Text>
                )}
            </div>
        </>
    );
};

export default translation(WaitingRecommendation);
